export const LoginAlertConstant = {
    LOGIN_SUCCESS : 'LOGIN_SUCCESS',
    LOGIN_ERROR : 'LOGIN_ERROR',
    LOGIN_REQUEST : 'LOGIN_REQUEST',
    LOGOUT : 'LOGOUT',
    CSRF_TOKEN_SUCCESS : 'CSRF_TOKEN_SUCCESS',
    PROXY_LOGIN_SUCCESS : 'PROXY_LOGIN_SUCCESS'
}